export default {
  common: {
    accept: 'Close'  ,
    confirmAccept: 'Yes',
    confirmReject: 'No'
  },
  configMenu: {
    aircraftTag: {
      active: 'Active',
      addAll: 'Add All',
      available: 'Available',
      resetAll: 'Reset All',
    },
    configOption: {
      edit: 'Edit',
      delete: 'Delete',
      duplicate: 'Duplicate'
    },
    contentPlaceholder: {
      contentHere: 'Content will go here.',
      creationPending: '--- CREATION PENDING ---',
    },
    itemManager: {
      active: 'ACTIVE',
      available: 'AVAILABLE',
      createNew: 'Create a new ',
    },
    optionsFilters: {
      flightStatusInput: {
        label: 'Flight State',
        placeholder: 'Choose state'
      },
      airlinesInput: {
        label: 'Airlines',
        placeholder: 'Choose airlines'
      },
      buttonSave: 'Save',
      chooseTags: 'Choose tags',
      destinationInput: {
        label: 'Destination',
        placeholder: 'Choose airports'
      },
      filterColor: 'Filter Color',
      filterTags: 'Filter Tags',
      flightTags: 'Flight Tags',
      itemSelectorWaiting1: 'Waiting for',
      itemSelectorWaiting2: 'to load...',
      matchAll: 'Match All',
      matchAny: 'Match Any',
      nameInput: {
        error: 'Filter already exists. Please use another name.',
        label: 'Name',
        placeholder: 'Enter the name of your filter'
      },
      noTags: 'No Tags',
      originInput: {
        label: 'Origin',
        placeholder: 'Choose airports'
      },
    },
    optionsMap: {
      aircraftDetails: {
        selectionList: 'Selection List'    
      }  
    },
    optionsSettings: {
      airportCode: 'Airport Code(s)',
      iconSize: 'Icon Size',
      radius: 'Radius in nm', 
      maxTimeAllowed: 'Maximum time limit allowed in minutes',
      holdOnly: 'Holding flights only',
      noOfCircles: 'No of circles',
    },
    optionsWeather: {
      resetAll: 'Reset All',
    },
  },
  fontCustomizer: {
    resizeTitle: 'Font Size',  
  },
  home: {
    buttonLogout: 'Logout',
    buttonRetry: 'Retry',
    internetFailed: 'Internet Connection Failed!',  
  },
  header: {
    buttonDelete: 'Delete', 
    buttonLoad: 'Load', 
    buttonSave: 'Save', 
    errorMessages: {
      deleteComponent: 'You cannot delete the active component',
      deleteLayout: 'You cannot delete the active layout',
      duplicateLayoutName: `A layout named {{layoutName}} already exists.`,
    },
    layoutName: {
      label: 'Layout Name',
      placeholder: 'Enter the name',
    },
    layoutLoading: `Loading {{layoutName}} layout...`,
    layoutManagement: {
      active: 'Active',
      addComponents: 'Add components',
      buildLayout: 'Build a new layout',
      buttonContinue: 'Continue',
      defaultComponents: 'Default components',
      dragComponents: 'Drag the component to the desired section.',
      inputName: {
        label: 'Name',
      },
      layoutDelete: 'Delete this layout?',  
      nameLayout: 'Name your layout',
      save: 'Save',
      savedComponents: 'Saved components',
      saveAsNew: 'Save as new',
      saveAsNewLayout: 'Save as new layout',
      tabAll: 'All',
      tabRecent: 'Recent',
      tabStarred: 'Starred',
    },
    myLayouts: 'My Layouts', 
    replay: {
      ongoing: 'Ongoing Replay Date and Time:',
      pause: 'Pause',
      resume: 'Resume',
      selectDateTime: 'Please select a date and time from the past 30 days:',
      selectSpeed: 'Please select a replay speed:',
      start: 'Start',
      stop: 'Stop',
    },
  },
  loading: 'Loading...',
  login: {
    authentication: 'Checking authentication ...',
    errorMsgAuth: 'Incorrect Username and/or Password',
    errorMsgNetw: 'A network error has occurred',
    buttonLogin: 'Login',
    inputUserName: 'Username',
    inputPassword: 'Password',
  },
  mainMenu: {
    themes: 'Themes',
    light: 'Light',
    dark: 'Dark',
    lightGrey: 'Light Grey',
    darkGrey: 'Dark Grey',
    layout: 'Layout',
    components: 'Components',
    replay: 'Replay',
    faaOis: 'FAA OIS',
    aviationWeather: 'Aviation Weather Center',
  },
  map: {
    flightInfo: 'Flight Information',  
  },
  tile: {
    saveComponent: {
      buttonSave: 'Save',
      saveOptions: 'Save Options'
    },
    tileSplitter: {
      componentName: {
        label: 'Component Name',
        placeholder: 'Enter the name'
      },
      defaultComponents: 'Default Components',
      position: 'Position',
      splitOptions: 'Split Options',
      splitToBottom: ' Split to Bottom',
      splitToLeft: ' Split to Left',
      splitToRight: ' Split to Right',
      splitToTop: ' Split to Top'
    },
    toolbar: {
      deleteTile: ' Delete Tile',
      options: ' Options',
      save: ' Save',
      split: ' Split',
      swap: ' Swap'
    } 
  }
}
